import { createContext } from 'react';

export interface FascinationContextValue {
  readonly animate: boolean;
  readonly registerRef: (ref: HTMLElement | null) => void;
  readonly unregisterRef: () => void;
}

export const FascinationContext = createContext<FascinationContextValue>({
  animate: false,
  registerRef: () => {},
  unregisterRef: () => {},
});
